import parsePhoneNumberFromString from 'libphonenumber-js';
import { CustomSocialLinksProfile } from '../CustomSocialLinks';

export const WhatsApp: CustomSocialLinksProfile = {
  name: 'whatsapp',
  matches: [
    {
      match: (input: string) => {
        const number = parsePhoneNumberFromString(
          (input || ''), !input?.includes('+') ? 'US' : null
        )?.number;
        return number?.toString();
      },
      pattern: 'https://wa.me/{PROFILE_ID}',
      type: 0
    }
  ]
};
